export const COLORS = {
    base: '#51A5CC',
    casual: '#8A38F5',
    extras: '#DF6B80',
    taken: 'var(--TA-color-state-info-main)',
    free: 'var(--TA-color-bg-surface-hover)',
    active: 'var(--TA-color-state-success-bg)',
    off: 'var(--TA-color-text-disabled)',
    rest: 'var(--TA-color-bg-surface-hover)',
};
